import { BadgePercent, Gift } from "lucide-react";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";
import { PROMOS } from "@/data/services";

export default function DealsPage() {
  return (
    <PageLayout eyebrow="Special Deals" title="Deals &" titleAccent="Promotions" bgImage="/deals-bg.jpg">
      <PageBody>
        <p className="max-w-2xl text-base text-slate-300 leading-relaxed">
          We run specials all season long. Mention the deal when you book or request a quote
          and we'll apply it to your appointment — no codes, no fine print.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {PROMOS.map((p) => (
            <div
              key={p.id}
              data-testid={`deals-card-${p.id}`}
              className="bg-[#121216] border border-[#232329] p-8 hover:border-[#EA0A0B]/60 transition-colors"
            >
              <BadgePercent className="w-8 h-8 text-[#EA0A0B]" />
              <p className="mt-5 font-display uppercase text-2xl tracking-wide text-white">{p.title}</p>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{p.description}</p>
              <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#EA0A0B]">{p.tag}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#121216] border border-[#232329] p-7 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-start gap-4">
            <Gift className="w-8 h-8 text-[#EA0A0B] shrink-0" />
            <div>
              <p className="font-display uppercase text-2xl tracking-wide text-white">Gift Certificates</p>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed max-w-xl">
                The easiest gift for any car lover — available for any package or dollar amount.
              </p>
            </div>
          </div>
          <BookNowButton to="/gifts" label="Shop Gift Certificates" testid="deals-gifts-button" />
        </div>

        <div className="mt-10">
          <BookNowButton to="/book" label="Book & Save Now" testid="deals-book-button" />
        </div>
      </PageBody>
    </PageLayout>
  );
}
